// extracted by mini-css-extract-plugin
export default {"price":"Oca-z","onSale":"Pca-z","msrpLabelPrice":"Qca-z","msrpLabel":"Rca-z","originalPrice":"Sca-z"};